import React from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import classnames from "classnames"
import { firestoreConnect } from "react-redux-firebase"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { toggleUserStatus } from "actions/organization/usersActions"
import { verifyMerchant } from "actions/organization/usersActions"
import { CustomPagination } from "components/Common"

import {
  Card,
  CardHeader,
  DropdownMenu,
  Badge,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  Table,
  Container,
  Row,
} from "reactstrap"

class Merchants extends React.Component {
  state = {
    start: 0,
    end: 0,
  }

  _handlePaginationClick(start, end) {
    if (start >= 0 && end >= 0) {
      this.setState({
        start,
        end,
      })
    }
  }

  render() {
    const { users } = this.props
    const { start, end } = this.state
    return (
      <>
        <SimpleHeader name="All Merchants" parentName="Merchants" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader className="border-0">
                  <h3 className="mb-0">Merchants</h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="text-center thead-light">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        Title
                      </th>
                      <th className="sort" data-sort="budget" scope="col">
                        Zip Code
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Verified
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Active
                      </th>
                      <th scope="col">Options</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="list">
                    {users &&
                      users.length > 0 &&
                      users.slice(start, end).map((user) => {
                        // user.id - Cloud Firestore Document Id
                        return (
                          <tr className="text-center" key={user.id}>
                            <th scope="row">
                              <Media className="align-items-center">
                                <a
                                  className="avatar rounded-circle mr-3"
                                  href="#fa"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    src={
                                      user.logo
                                        ? user.logo
                                        : require("assets/img/theme/blank-profile.png")
                                    }
                                  />
                                </a>
                                <Media>
                                  <span className="name mb-0 text-sm">
                                    {user.name}
                                  </span>
                                </Media>
                              </Media>
                            </th>
                            <td className="budget">
                              {user.zipCode &&
                                user.zipCode.length > 0 &&
                                user.zipCode.map((code, key) => {
                                  return (
                                    <React.Fragment key={key}>
                                      {code}
                                      <br />
                                    </React.Fragment>
                                  )
                                })}
                            </td>
                            <td className="text-center">
                              <Badge color="" className="badge-dot">
                                <i
                                  className={classnames(
                                    { "bg-success": user.verified === true },
                                    { "bg-warning": user.verified === false }
                                  )}
                                />
                                <span
                                  className={classnames(
                                    "status",
                                    { "text-success": user.verified === true },
                                    { "text-warning": user.verified === false }
                                  )}
                                >
                                  {user.verified ? "Yes" : "No"}
                                </span>
                              </Badge>
                            </td>
                            <td className="text-center">
                              <Badge color="" className="badge-dot">
                                <i
                                  className={classnames(
                                    { "bg-success": user.status === "enabled" },
                                    { "bg-warning": user.status === "disabled" }
                                  )}
                                />
                                <span
                                  className={classnames(
                                    "status",
                                    {
                                      "text-success": user.status === "enabled",
                                    },
                                    {
                                      "text-warning":
                                        user.status === "disabled",
                                    }
                                  )}
                                >
                                  {user.status}
                                </span>
                              </Badge>
                            </td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  {user.verified ? (
                                    ""
                                  ) : (
                                    <DropdownItem
                                      onClick={() =>
                                        this.props.verifyMerchant({
                                          uid: user.id,
                                        })
                                      }
                                    >
                                      Verify
                                    </DropdownItem>
                                  )}
                                  <DropdownItem
                                    onClick={() =>
                                      this.props.toggleUserStatus({
                                        uid: user.id,
                                        disabled:
                                          user.status === "disabled"
                                            ? "enabled"
                                            : "disabled",
                                      })
                                    }
                                  >
                                    {user.status === "disabled"
                                      ? "Enable User"
                                      : "Disable User"}
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
                <CustomPagination
                  pageSize={5}
                  dataLen={this.props.users ? this.props.users.length : 0}
                  stateCallback={this._handlePaginationClick.bind(this)}
                />
              </Card>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    oid: state.firebase.auth.uid,
    users: state.firestore.ordered.allMerchants,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleUserStatus: (data) => dispatch(toggleUserStatus(data)),
    verifyMerchant: (data) => dispatch(verifyMerchant(data)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "merchants",
      storeAs: "allMerchants",
    },
  ])
)(Merchants)
